import React from 'react';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { successMessages as messages } from './DisabledTimeWindows.messages';

const SuccessDisabledTimeWindowModal = () => (
  <Confirm title={<Message message={messages.title} />} acceptNode={<Message message={messages.accept} />}>
    <Message message={messages.body} />
  </Confirm>
);

export default SuccessDisabledTimeWindowModal;
